module.exports = __webpack_public_path__ + "img/delete_dark.e24fa3a8.svg";